// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.status-select{
    width: 185px;
    height: 40px;
    border-radius: 10px !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/statusSelector/statusSelector.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,YAAY;IACZ,8BAA8B;AAClC","sourcesContent":[".status-select{\n    width: 185px;\n    height: 40px;\n    border-radius: 10px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
